module.exports = __webpack_public_path__ + "static/media/full-minus.47c95a8f.svg";